export default [
    {
      url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Black.fft"})`,
      name: 'Lato Black',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-BlackItalic.fft"})`,
        name: 'Lato Black Italic',
      },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Bold.fft"})`,
        name: 'Lato Bold',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-BoldItalic.fft"})`,
        name: 'Lato Bold Italic',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Italic.fft"})`,
        name: 'Lato Italic',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Light.fft"})`,
        name: 'Lato Light',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-LightItalic.fft"})`,
        name: 'Lato Light Italic',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Regular.fft"})`,
        name: 'Lato Regular',
    },
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Thin.fft"})`,
        name: 'Lato Thin',
    },                  
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-ThinItalic.fft"})`,
        name: 'Lato Thin Italic',
    },      
    {
        url: `url(${process.env.PUBLIC_URL + "/fonts/Lato-Regular.fft"})`,
        name: 'Lato, sans-serif',
    },    
]